module.exports = __webpack_public_path__ + "5029a58a27c3daf48f5a3a6f55ee8aef.png";